import React from "react";
import { useQuickSightSagemaker } from "@/hooks/useSagemakerReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsSagemakerDashboard from "@/components/organisms/SagemakerDashboard";

function SagemakerReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightSagemaker();

  return (
    <AWSReportsTemplate
      title="AWS Sagemaker Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsSagemakerDashboard />
    </AWSReportsTemplate>
  );
}

export default SagemakerReports;
